import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Column, IconButton, Row, Spinner, TextButton, Typography } from 'seagull';
import { PDF } from 'seagull/icons/content-edit';
import { Eye } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { formatFileSize } from '~/utils/fileSize.utils';
import s from './UploadedPdfRow.module.scss';
export const GetUploadedPdfRowTID = (parentTestId)=>getTestIds(parentTestId);
export const UploadedPdfRow = (param)=>{
    let { pdfFileName, fileSizeBytes, onChangeFile, onPreview, isUploading, testId } = param;
    const { t } = useLocaleKeys();
    const testIds = useMemo(()=>GetUploadedPdfRowTID(testId), [
        testId
    ]);
    const formattedSize = useMemo(()=>fileSizeBytes != null ? formatFileSize(fileSizeBytes, {
            unitSeparator: '',
            decimalPlaces: 0
        }) : undefined, [
        fileSizeBytes
    ]);
    if (isUploading) {
        return /*#__PURE__*/ _jsx(Row, {
            testId: testIds.UploadedPdfRowTestIds.Root(),
            className: s.root,
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ _jsx(Spinner, {
                size: 32,
                testId: testIds.UploadedPdfRowTestIds.Spinner()
            })
        });
    }
    return /*#__PURE__*/ _jsxs(Row, {
        testId: testIds.UploadedPdfRowTestIds.Root(),
        className: s.root,
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 16,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        className: s.pdfIcon,
                        testId: testIds.UploadedPdfRowTestIds.PdfIcon(),
                        children: /*#__PURE__*/ _jsx(PDF, {
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                gap: 4,
                                alignItems: "baseline",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        weight: "normal",
                                        variant: "paragraph1",
                                        testId: testIds.UploadedPdfRowTestIds.FileName(),
                                        children: pdfFileName
                                    }),
                                    formattedSize != null && /*#__PURE__*/ _jsxs(Typography, {
                                        weight: "light",
                                        variant: "paragraph1",
                                        skin: "secondary",
                                        testId: testIds.UploadedPdfRowTestIds.FileSize(),
                                        children: [
                                            "(",
                                            formattedSize,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            onChangeFile != null && /*#__PURE__*/ _jsx(TextButton, {
                                skin: "primary",
                                variant: "paragraph2",
                                underline: "hover",
                                onClick: onChangeFile,
                                bi: {
                                    name: 'change_pdf_file'
                                },
                                testId: testIds.UploadedPdfRowTestIds.ChangeFileLink(),
                                children: t.customPages.pdfUpload.changeFile()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                skin: "transparent",
                size: "smallMedium",
                onClick: onPreview,
                bi: {
                    name: 'preview_pdf'
                },
                testId: testIds.UploadedPdfRowTestIds.PreviewButton(),
                children: /*#__PURE__*/ _jsx(Eye, {
                    size: 24
                })
            })
        ]
    });
};
